import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { ExpandMore, VerticalAlignCenter, Error } from "@mui/icons-material"
import { Accordion, AccordionSummary, AccordionDetails, FormControlLabel, Radio, TextField, InputAdornment, Typography } from "@mui/material"
import { percentageFormatter } from "helpers/formatters/numbers"
import { treatAsFactor } from "helpers/securities"
import { TRADE } from "../../shapes"
import "./styles.scss"

function onFocus(event) {
  event.target.select()
}

function getIcon(constraintType, minError, maxError) {
  if (minError || maxError) {
    return <Error color="error" style={{ fontSize: 20 }} />
  } else if (constraintType === "fixed") {
    return <VerticalAlignCenter color="primary" style={{ fontSize: 20 }} />
  } else if (constraintType === "range") {
    return <Typography color="primary">+/-</Typography>
  }
}
export default class Trades extends Component {
  static propTypes = {
    trade: TRADE.isRequired,
    openTradeId: PropTypes.string,
    constraints: PropTypes.object.isRequired,
    setTradeConstraint: PropTypes.func.isRequired,
    setOpenTradeId: PropTypes.func.isRequired,
    openSecurityProfile: PropTypes.func.isRequired,
    openFactorProfile: PropTypes.func.isRequired,
  }

  onClick = event => {
    event.stopPropagation()
    const { trade: { ticker, mic, assetClass }, openFactorProfile, openSecurityProfile } = this.props

    if (treatAsFactor(assetClass)) {
      openFactorProfile(ticker)
    } else {
      openSecurityProfile(mic, ticker)
    }
  }

  onChange = () => {
    const { trade: { key }, setOpenTradeId } = this.props
    setOpenTradeId(key)
  }

  setConstraint = event => {
    const { trade: { key, ticker, mic, originalPercentEquity }, setTradeConstraint } = this.props
    const constraintType = event.target.value === "none" ? null : event.target.value

    setTradeConstraint(ticker, mic, key, constraintType, originalPercentEquity)
  }

  onMinChanged = event => {
    const { trade: { key, ticker, mic, originalPercentEquity }, setTradeConstraint } = this.props
    const min = event.target.value === "none" ? null : event.target.value

    setTradeConstraint(ticker, mic, key, "range", originalPercentEquity, { min })
  }

  onMaxChanged = event => {
    const { trade: { key, ticker, mic, originalPercentEquity }, setTradeConstraint } = this.props
    const max = event.target.value === "none" ? null : event.target.value

    setTradeConstraint(ticker, mic, key, "range", originalPercentEquity, { max })
  }

  render() {
    const { trade: { label, percentEquity, key, originalPercentEquity, type }, openTradeId, constraints } = this.props
    let constraintType, min, max, minError, maxError

    const constraint = constraints[key]
    if (constraint) {
      constraintType = constraint.constraintType
      min = constraint.min
      max = constraint.max
      minError = constraint.minError
      maxError = constraint.maxError
    } else {
      constraintType = "none"
    }

    const percentValue = percentageFormatter(Math.abs(percentEquity))
    const expPanelDetails = <ol>
      <li className="option">
        <FormControlLabel control={<Radio value="none" onChange={this.setConstraint} checked={constraintType === "none"} />} label="Unrestricted" />
      </li>
      <li className="option">
        <FormControlLabel control={<Radio value="fixed" onChange={this.setConstraint} checked={constraintType === "fixed"} />} label={`Fix to Base % Equity:   ${percentageFormatter(originalPercentEquity)}`} />
      </li>
      <li className="option">
        <FormControlLabel control={<Radio value="range" onChange={this.setConstraint} checked={constraintType === "range"} />} label="Set Trade Range" />
        {constraintType === "range" && <div className="trade-range">
          <TextField
            variant="standard"
            error={!!minError}
            name="min"
            value={min}
            onChange={this.onMinChanged}
            onFocus={onFocus}
            color="secondary"
            type="number"
            helperText={minError || "min"}
            slotProps={{
              input: {
                startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start">%</InputAdornment>,
              },

              htmlInput: {
                step: 0.5,
              },
            }}
          />
          <span>to</span>
          <TextField
            variant="standard"
            error={!!maxError}
            name="max"
            value={max}
            onChange={this.onMaxChanged}
            onFocus={this.onFocus}
            color="secondary"
            type="number"
            helperText={maxError || "max"}
            slotProps={{
              input: {
                startAdornment: <InputAdornment style={{ whiteSpace: "nowrap" }} position="start">%</InputAdornment>,
              },

              htmlInput: {
                step: 0.5,
              },
            }}
          />
        </div>}
      </li>
    </ol>

    return <Accordion className="trade" expanded={key === openTradeId} onChange={this.onChange}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <div className="contraint-type">
          {getIcon(constraintType, minError, maxError)}
        </div>
        <a className="security" onClick={this.onClick}>{label}</a>
        <div className={classnames("percent", {
          negative: percentEquity < 0 && percentValue !== "0.00%",
        })}
        >
          {percentValue}
        </div>
      </AccordionSummary>
      <AccordionDetails className="options">
        {(type === "swaps" || type === "equities") ? expPanelDetails
          : <div className="trade-constraint-disabled">Only equities and swaps can be optimized</div>}
      </AccordionDetails>
    </Accordion>
  }
}
